var _circle, _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardMini(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 15,
    viewBox: "0 0 30 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.3436,
    cy: 7.96894,
    r: 7.03107,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7227 5.24426C19.8359 5.13529 20.0153 5.13609 20.1275 5.24606L22.1602 7.71478C22.302 7.85378 22.3006 8.08237 22.1571 8.21961L20.1631 10.708C20.1139 10.755 20.0485 10.7812 19.9805 10.7812L18.3063 10.7812C18.0703 10.7812 17.9529 10.4955 18.1209 10.3299L20.164 7.9688L18.3063 5.6837H17.561L19.3377 7.71489C19.4827 7.85326 19.4829 8.08448 19.338 8.223L17.0036 10.708C16.9545 10.755 16.8891 10.7812 16.821 10.7812H14.1796C13.5973 10.7812 13.1252 10.3093 13.1251 9.72694C13.1249 8.55496 13.1251 7.38297 13.1252 6.21099C13.1252 5.62853 13.5974 5.15637 14.1799 5.15637H15.229C15.3748 5.15637 15.493 5.27442 15.493 5.42004C15.493 5.56566 15.3748 5.6837 15.229 5.6837H14.3562C13.9679 5.6837 13.6531 5.99849 13.6531 6.38681C13.6531 7.44147 13.6531 8.49613 13.6531 9.55079C13.6531 9.93911 13.9679 10.2539 14.3562 10.2539H16.6257L18.7563 7.9688L16.7131 5.60769C16.5451 5.44209 16.6625 5.15637 16.8985 5.15637H18.5304C18.5984 5.15637 18.6638 5.1826 18.7129 5.2296L20.7458 7.7146C20.8906 7.85313 20.8905 8.08435 20.7455 8.22271L18.9688 10.2539H19.7608L21.5718 7.9688L19.7227 5.6837C19.6069 5.5692 19.6054 5.35726 19.7227 5.24426Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5635 0C13.6383 0.322751 12.7866 0.802099 12.04 1.40625H2.34375C1.82604 1.4063 1.40625 1.82603 1.40625 2.34375V10.7656C1.40626 11.2917 1.83327 11.7178 2.35938 11.7178H9.7832C10.031 12.2163 10.3266 12.6874 10.6641 13.124H1.98535C0.88911 13.124 0.000253641 12.2358 0 11.1396V1.875C0 0.839528 0.839542 5.77286e-05 1.875 0H14.5635ZM6.09375 3.28125C6.6115 3.28125 7.03125 3.701 7.03125 4.21875V6.09375C7.03113 6.6114 6.61143 7.03125 6.09375 7.03125H4.21875C3.70111 7.03121 3.28137 6.61137 3.28125 6.09375V4.21875C3.28125 3.70102 3.70103 3.28129 4.21875 3.28125H6.09375Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.0371,
    y: 0.417114,
    width: 0.834555,
    height: 13.3529,
    rx: 0.417277,
    fill: "#141413"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardMini);
export default __webpack_public_path__ + "static/media/card-mini.2cf24469592e195c3541e6195bd4993b.svg";
export { ForwardRef as ReactComponent };